import { create } from "zustand";

import {
  closeSiblingDrawers,
  registerSidebarDrawer,
} from "./sidebar-drawer-coordinator";

interface TeamChatDrawerState {
  isOpen: boolean;
  isLocked: boolean;
  activeConversationId: string | null;
  openDrawer: () => void;
  closeDrawer: () => void;
  lockDrawer: () => void;
  setActiveConversation: (id: string | null) => void;
}

export const useTeamChatDrawerStore = create<TeamChatDrawerState>((set) => ({
  isOpen: false,
  isLocked: false,
  activeConversationId: null,
  openDrawer: () => {
    closeSiblingDrawers("team-chat");
    set({ isOpen: true });
  },
  closeDrawer: () => set({ isOpen: false, isLocked: false }),
  lockDrawer: () => set({ isLocked: true }),
  setActiveConversation: (id) => set({ activeConversationId: id }),
}));

registerSidebarDrawer("team-chat", () =>
  useTeamChatDrawerStore.getState().closeDrawer(),
);
